<template>
  <div>
    <treatment-history-detail
      backRoute="AdminNurseDetails"
      patientDetailRoute="SubAdminPatientDetail"
    />
  </div>
</template>
<script>
import PatientTreatmentHistoryDetails from '../../general-component/treatment-history/TreatmentDetails';
export default {
  name: 'SuperAdminPatientDetails',
  components: {
    'treatment-history-detail': PatientTreatmentHistoryDetails,
  },
  data() {
    return {};
  },
};
</script>
